import { render, staticRenderFns } from "./CreateTemplatePage.vue?vue&type=template&id=66246be5&"
import script from "./CreateTemplatePage.js?vue&type=script&lang=js&"
export * from "./CreateTemplatePage.js?vue&type=script&lang=js&"
import style0 from "./CreateTemplatePage.vue?vue&type=style&index=0&id=66246be5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports